import type React from 'react';
import type { PropsWithChildren } from 'react';

import type { TabScreenProps } from './types';

export const Screen: React.FC<PropsWithChildren<TabScreenProps>> = ({
  isHidden,
  children,
}) => {
  if (isHidden) {
    return null;
  }

  return <>{children}</>;
};
